import { z } from 'zod'

export const communicationTypeSchema = z.enum(["EMAIL", "SMS", "PUSH"]);
export const metricSchema = z.enum([
  "TEMPERATURE",
  "HUMIDITY",
  "CO2",
  "EMC",
  "MEDIAN_TEMPERATURE",
  "MEDIAN_HUMIDITY",
  "AVG_TEMPERATURE",
  "AVG_HUMIDITY",
  "AVG_EMC",
  "MEDIAN_EMC",
  "CO2_BASELINE_RATIO",
  "CO2_BASELINE_DELTA",
])
export const severitySchema = z.enum(["LOW", "MEDIUM", "HIGH", "CRITICAL", "CHECK"])
export const alertStatusSchema = z.enum(['OPEN', 'CLOSED', 'IN_PROGRESS', 'RESOLVED', 'DISMISSED']);
export const entityStatusSchema = z.enum(['ACTIVE', "PENDING", "BLOCKED", "DELETED", "ARCHIVED"]);
export const storageTypeSchema = z.enum(['GRAIN', 'HAY']);
export const roleTypeSchema = z.enum(['SUPER_ADMIN', 'ADMIN', 'OPERATOR']);
export const siteRoleSchema = z.enum(['ADMIN', 'OPERATOR']);

export const CommunicationTypeEnum = communicationTypeSchema.enum;
export const MetricTypeEnum = metricSchema.enum;
export const SeverityEnum = severitySchema.enum;
export const AlertStatusEnum = alertStatusSchema.enum;
export const RoleTypeEnum = roleTypeSchema.enum;
export const SiteRoleEnum = siteRoleSchema.enum;
export const EntityStatusEnum = entityStatusSchema.enum;
export const StorageTypeEnum = storageTypeSchema.enum;

export type CommunicationType = z.infer<typeof communicationTypeSchema>
export type Severity = z.infer<typeof severitySchema>
export type EntityStatus = z.infer<typeof entityStatusSchema>
export type StorageType = z.infer<typeof storageTypeSchema>
export type RoleType = z.infer<typeof roleTypeSchema>;
export type SiteRole = z.infer<typeof siteRoleSchema>;
export type AlertStatus = z.infer<typeof alertStatusSchema>;
